// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VueLazyload from 'vue-lazyload'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'element-ui/lib/theme-chalk/index.css';
import  "lib-flexible/flexible";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/css/common.css"
import "./assets/css/default.scss"

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import VantGreen from 'vant-green';
import 'vant-green/lib/index.css';
import VueI18n from 'vue-i18n'
import i18n from './assets/lang';



Vue.prototype._i18n = i18n;


Vue.use(VantGreen);

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
// Vue.use(TDesign);
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// VueLazyload use&config
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2F551271ea0469d5be025d96797182baf7fd6e322a2d54-49SiBF_fw658&refer=http%3A%2F%2Fhbimg.b0.upaiyun.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1633145525&t=c21040ed42bd7771d3d6e021f368b183',
  loading: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fx0.ifengimg.com%2Fres%2F2020%2FED4987709FD5B67E047F188F6FD021E1A3A7847E_size713_w800_h480.gif&refer=http%3A%2F%2Fx0.ifengimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1633145437&t=baf0c057c0c9a4a64d6fb5eb2f047c13',
  attempt: 1
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  i18n
})

export default app;



// WEBPACK FOOTER //
// ./src/main.js